module.exports = __webpack_public_path__ + "static/media/referral-program-1.8fd98ffd.jpg";